import { Typography, useTheme } from '@material-ui/core';

import { AppSwitch } from '../../../../components/AppSwitch';
import { monochrome } from '../../../../theme/styles';

export const ActionTypeSwitch = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
}) => {
  const theme = useTheme();
  return (
    <AppSwitch
      activeColor={theme.palette.primary.main}
      inactiveColor={monochrome.mediumlight}
      checked={checked}
      onChange={onChange}
      leftOption={{
        content: (
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: monochrome.lightest,
            }}>
            Add
          </Typography>
        ),
      }}
      rightOption={{
        content: (
          <Typography
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: monochrome.lightest,
            }}>
            Remove
          </Typography>
        ),
      }}
    />
  );
};
